export default __webpack_public_path__ + "910e1167f0277e399c4aeff72700ccd4.woff2";